import { render, staticRenderFns } from "./InviteMultipleCandidates.vue?vue&type=template&id=18dfbde6&scoped=true"
import script from "./InviteMultipleCandidates.vue?vue&type=script&lang=js"
export * from "./InviteMultipleCandidates.vue?vue&type=script&lang=js"
import style0 from "./InviteMultipleCandidates.vue?vue&type=style&index=0&id=18dfbde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfbde6",
  null
  
)

export default component.exports